import { render, staticRenderFns } from "./AvatarColor.vue?vue&type=template&id=c1b1e67e&"
import script from "./AvatarColor.vue?vue&type=script&lang=js&"
export * from "./AvatarColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports